export const BUSINESS_ACTIVITY_KIND = {
  PRIVATE_PERSON: "private_person",
  OTHER_BUSINESS: "other_business",
  SELF_EMPLOYED: "self_employed"
};

export const INVOICE_DATA_FIELDS = {
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  NIP: "nip",
  COMPANY_NAME: "companyName",
  STREET: "street",
  STREET_NUMBER: "streetNumber",
  FLAT_NUMBER: "flatNumber",
  CITY: "city",
  POSTAL_CODE: "postalCode",
  COUNTRY: "country"
};

export const DEFAULT_INVOICE_COUNTRY = "PL";

export const FORM_DATA_KEY_BY_KIND = {
  [BUSINESS_ACTIVITY_KIND.PRIVATE_PERSON]: "privatePersonData",
  [BUSINESS_ACTIVITY_KIND.OTHER_BUSINESS]: "otherBusinessData",
  [BUSINESS_ACTIVITY_KIND.SELF_EMPLOYED]: "selfEmployedData"
};

export const SAVED_DATA_KEY_BY_KIND = {
  [BUSINESS_ACTIVITY_KIND.PRIVATE_PERSON]: "savedPrivatePersonData",
  [BUSINESS_ACTIVITY_KIND.OTHER_BUSINESS]: "savedOtherBusinessData",
  [BUSINESS_ACTIVITY_KIND.SELF_EMPLOYED]: "savedSelfEmployedData"
};

export const REQUIRED_FIELDS_BY_KIND = {
  [BUSINESS_ACTIVITY_KIND.PRIVATE_PERSON]: [
    INVOICE_DATA_FIELDS.FIRST_NAME,
    INVOICE_DATA_FIELDS.LAST_NAME,
    INVOICE_DATA_FIELDS.STREET,
    INVOICE_DATA_FIELDS.STREET_NUMBER,
    INVOICE_DATA_FIELDS.POSTAL_CODE,
    INVOICE_DATA_FIELDS.CITY,
    INVOICE_DATA_FIELDS.COUNTRY
  ],
  [BUSINESS_ACTIVITY_KIND.OTHER_BUSINESS]: [
    INVOICE_DATA_FIELDS.NIP,
    INVOICE_DATA_FIELDS.COMPANY_NAME,
    INVOICE_DATA_FIELDS.STREET,
    INVOICE_DATA_FIELDS.STREET_NUMBER,
    INVOICE_DATA_FIELDS.POSTAL_CODE,
    INVOICE_DATA_FIELDS.CITY,
    INVOICE_DATA_FIELDS.COUNTRY
  ],
  [BUSINESS_ACTIVITY_KIND.SELF_EMPLOYED]: [
    INVOICE_DATA_FIELDS.NIP,
    INVOICE_DATA_FIELDS.COMPANY_NAME,
    INVOICE_DATA_FIELDS.FIRST_NAME,
    INVOICE_DATA_FIELDS.LAST_NAME,
    INVOICE_DATA_FIELDS.STREET,
    INVOICE_DATA_FIELDS.STREET_NUMBER,
    INVOICE_DATA_FIELDS.POSTAL_CODE,
    INVOICE_DATA_FIELDS.CITY,
    INVOICE_DATA_FIELDS.COUNTRY
  ]
};

export const OPTIONAL_VISIBLE_FIELDS = [INVOICE_DATA_FIELDS.FLAT_NUMBER];

export const visibleFieldsForKind = kind => [
  ...(REQUIRED_FIELDS_BY_KIND[kind] ?? []),
  ...OPTIONAL_VISIBLE_FIELDS
];
